/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetSearchPrivacySettingsRequest} from '@cash-web/protos/squareup/cash/customersearch/api/privacy/Privacy.pb'
import {SetSearchPrivacySettingsResponse} from '@cash-web/protos/squareup/cash/customersearch/api/privacy/Privacy.pb'


export const setPrivacySettings = (request:SetSearchPrivacySettingsRequest, options?: CashRequestOptions) => post<SetSearchPrivacySettingsRequest, SetSearchPrivacySettingsResponse>("/2.0/cash/set-privacy-settings", request, {...options, rejectOnError: true })